// 引入axios
import axios from "axios";
import { Toast } from "vant";

// const BASE_ENV = process.env.BASE_ENV;
const baseURL = `https://api.ihatoo.net/hatu/`;
// console.log(BASE_ENV);

// 创建axios实例
const service = axios.create({
  baseURL, // api的base_url  Vue项目可以根据 process.env.BASE_API，React可以在这里定义
  timeout: 50000, // 请求超时时间
  withCredentials: false // 跨域携带cookie
  //   xsrfCookieName: 'xsrf-token'  //当创建实例的时候配置默认配置
});

// 添加请求拦截器，这里面可以配置一下每次请求都需要携带的参数，比如 token，timestamp等等，根据项目自己配置
service.interceptors.request.use(
  config => {
    Toast.loading({
      message: "加载中...",
      forbidClick: true,
      duration: 0,
      overlay: true
    });
    return config;
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器 ，这里的 response是接收服务器返回后的结果，也可以在这里做一些状态判断
service.interceptors.response.use(
  response => {
    /**
     * 判断服务器请求是否成功
     * @method if
     * @param  {[type]} response [description]
     * @return {[type]}          [description]
     */
    // Toast.clear();
    const res = response.data;
    Toast.clear();
    if (res.code !== 200) {
      switch (res.code) {
        default:
          Toast(res.msg);
          break;
      }
    } else {
      return res;
    }
  },
  error => {
    // console.log(error.response.data)
    Toast.loading({
      message: error.message,
      type: "loading ",
      forbidClick: true,
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);
// 提供axios给外部调用
export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js